import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { MuiButtonStyled } from './Button.styled';
/**
 * **Global Parts** `Button` component.
 *
 * Additional properties: `float`.
 */
// `forwardRef` drops MUI's polymorphic `ExtendButton` signature (`component`, `to`), so the cast restores it.
const Button = forwardRef((props, ref) => (_jsx(MuiButtonStyled, { ref: ref, ...props })));
export { Button };
